module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAIVBMVEUAAABAQECAgIA0NDQzMzM6Ojo0NDQzMzM0NDQ9PT00NDSEnkR3AAAAC3RSTlMADALt0BbP/9QV09TkPekAAACASURBVHjahdNLCsMwDEBBf2LF6f0PXEMLWgwi3sVvUGxCWuujlWv00+e1qr6u2duIe6+i7zvO+GcXYv0Cgo6gI+gp6Ai7IrvioSMYhqAj/qwW2QtBB3wAL6/wkMzwmkfUHUFH0BH0FHSF3a18UNgRdMWI7IoYrc+oP07M/vr7fwGk/ghdFZ2LKAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/close.png
// module id = JA1j
// module chunks = 1